var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 3.9375C3.375 3.9375 1.125 9 1.125 9C1.125 9 3.375 14.0625 9 14.0625C14.625 14.0625 16.875 9 16.875 9C16.875 9 14.625 3.9375 9 3.9375ZM9 11.8125C8.44374 11.8125 7.89997 11.6476 7.43746 11.3385C6.97495 11.0295 6.61446 10.5902 6.40159 10.0763C6.18872 9.56238 6.13302 8.99688 6.24154 8.45131C6.35006 7.90574 6.61793 7.4046 7.01126 7.01126C7.4046 6.61793 7.90574 6.35006 8.45131 6.24154C8.99688 6.13302 9.56238 6.18872 10.0763 6.40159C10.5902 6.61446 11.0295 6.97495 11.3385 7.43746C11.6475 7.89997 11.8125 8.44374 11.8125 9C11.8125 9.74592 11.5162 10.4613 10.9887 10.9887C10.4613 11.5162 9.74592 11.8125 9 11.8125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 2.8125L14.625 15.1875",
    stroke: "black",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8914 11.0814C10.3753 11.5543 9.69998 11.8154 9.00001 11.8127C8.43235 11.8126 7.87799 11.6408 7.40982 11.3198C6.94165 10.9988 6.58157 10.5436 6.37693 10.0141C6.17228 9.48463 6.13265 8.90561 6.26324 8.35318C6.39383 7.80074 6.68853 7.30076 7.1086 6.91895",
    stroke: "black",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20312 4.82324C2.33438 6.27168 1.125 8.9998 1.125 8.9998C1.125 8.9998 3.375 14.0623 9 14.0623C10.3181 14.073 11.6197 13.7693 12.7969 13.1764",
    stroke: "black",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6672 11.8899C16.2 10.5188 16.875 9.00002 16.875 9.00002C16.875 9.00002 14.625 3.93752 9.00002 3.93752C8.51238 3.93655 8.02551 3.97654 7.54456 4.05705",
    stroke: "black",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52734 6.23682C10.1255 6.35014 10.6705 6.65494 11.0802 7.10521C11.4898 7.55548 11.7419 8.12678 11.7984 8.73291",
    stroke: "black",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide.c67b6bd7.svg";
export { ForwardRef as ReactComponent };